$.url = function(url) {
	return $('#siteRoot').attr('href')+'/v2'+url;
};

$.oldUrl = function(url) {
	return $('#siteRoot').attr('href')+url;
};

function registerHandlebarsSelectHelper () {
	window.Handlebars.registerHelper('select', function( value, options ){
		var $el = $('<select />').html( options.fn(this) );
		$el.find('[value=' + value + ']').attr({'selected':'selected'});
		return $el.html();
	});
}
